<script lang="ts">
	import type { BorderRadiusPosition } from '$lib/components/map/markers/types';
	import { formatPrice } from '$lib/utils/formatPrice';
	import { languageTag } from '$paraglide/runtime';

	interface Props {
		hours?: number;
		minutes?: number;
		totalCost?: { amount: number; currency: string };
		borderRadiusPosition?: BorderRadiusPosition;
		selected?: boolean;
	}

	const {
		hours,
		minutes,
		totalCost,
		borderRadiusPosition,
		selected = false,
	}: Props = $props();

	const borderRadiusClasses = {
		topLeft: 'border-rd-2 border-rd-tl-0',
		topRight: 'border-rd-2 border-rd-tr-0',
		bottomLeft: 'border-rd-2 border-rd-bl-0',
		bottomRight: 'border-rd-2 border-rd-br-0',
	};

	function getDateTime(hours: number | undefined, minutes: number | undefined): string {
		if (!hours && !minutes) {
			return '';
		}

		return `PT${hours ? `${hours}H` : ''}${minutes ? `${minutes}M` : ''}`;
	}
</script>

<div
	class={[
		'flex flex-col justify-center py-0.5 px-1 text-sm',
		selected ? 'bg-coloredneutral' : 'bg-neutral-weakest',
		selected ? 'text-neutral-weakest' : 'text-coloredneutral',
		selected ? 'shadow-focus hover:shadow-hover' : 'shadow-route-marker hover:shadow-hover',
		borderRadiusPosition && borderRadiusClasses[borderRadiusPosition],
	]}
>
	{#if hours || minutes}
		<time class="flex justify-start flex-items-end gap-0.5" datetime={getDateTime(hours, minutes)}>
			{#if hours}
				<span class="text-bold">{hours}</span>h
			{/if}
			{#if minutes}
				<span class="text-bold">{minutes}</span>min
			{/if}
		</time>
	{/if}

	{#if totalCost}
		<div class="flex justify-start">
			{formatPrice({
				amount: totalCost.amount,
				currency: totalCost.currency,
				language: languageTag(),
				digits: 2,
			})}
		</div>
	{/if}
</div>
